import axios from 'axios';
import type { Organization } from '@/types';

export const getAuthConfig = async (): Promise<Organization> => {
  const api_url = import.meta.env.VITE_API_URL;
  if (!api_url) {
    throw new Error('VITE_API_URL environment variable is not set. Please create a .env file with VITE_API_URL.');
  }
  const resp = await axios.get<Organization>(
    `${api_url}/v1/config/auth`,
  );
  return resp.data;
};

